export function bytesToTiB(bytes: number): string {
  // 1 TiB (tebibyte) = 1024^4 bytes
  const TiB = bytes / Math.pow(1024, 4);
  return TiB.toLocaleString('en-GB', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
}
